import { ref } from 'vue';

// This composable manages a single global toast for the app
export const toastState = ref({
  show: false,
  message: '',
  kind: 'base',
  important: false,
  hideClose: true,
  actionLabel: null as string | null,
  action: null as (() => void) | null,
  duration: 6000,
  icon: null as string | null,
});

export function useGlobalToast() {
  function showToast({
    message,
    kind = 'base',
    important = false,
    hideClose = true,
    duration = 6000,
    actionLabel = null,
    action = null,
    icon = null,
  }: {
    message: string;
    kind?: string;
    important?: boolean;
    hideClose?: boolean;
    duration?: number;
    actionLabel?: string | null;
    action?: (() => void) | null;
    icon?: string | null;
  }) {
    // Clear previous action to avoid accidental execution
    toastState.value.action = null;
    toastState.value.actionLabel = null;

    toastState.value = {
      show: false,
      message,
      kind,
      important,
      hideClose,
      actionLabel,
      action,
      duration,
      icon,
    }; // Include icon in state
    setTimeout(() => {
      toastState.value = {
        show: true,
        message,
        kind,
        important,
        hideClose,
        actionLabel,
        action,
        duration,
        icon,
      }; // Include icon in state
      if (!actionLabel) {
        // Only auto-hide if there's no action
        setTimeout(() => {
          if (toastState.value.show && !toastState.value.actionLabel) {
            // Check again in case another toast was shown
            toastState.value.show = false;
          }
        }, duration);
      }
    }, 10);
  }
  return { toastState, showToast };
}
